export const SECTIONS_IDS = {
  first: 'first',
  products: 'products',
  solutions: 'solutions',
  developers: 'developers',
  resources: 'resources',
  faq: 'faq',
  contact: 'contact',
};
